import fetch,{postFrom} from '../utils/fetch';

// 下拉框数据
export function getSelectedData() {
  return fetch({
      method: 'GET',
      url: 'houseTypeConfig/condition'
  })
}

// 户型配置列表
export function getList(params) {
  return fetch({
      method: 'GET',
      url: 'houseTypeConfig/list',
      params
  })
}

/* 
房型显示禁止
data: {houseTypeConfigFid,houseTypeConfigStatus}
*/

export function showOrForbid(data) {
  return postFrom('houseTypeConfig/showOrForbid',data)
}

// 查询物品配置 
export function getFacilities(params) {
  return fetch({
      method: 'GET',
      url: 'houseTypeConfig/getFacilities',
      params
  })
}

// 保存物品配置
export function saveFacilities(data) {
  return fetch({
      method: 'POST',
      url: 'houseTypeConfig/saveFacilities',
      data
  })
}
// 修改房型配置
export function houseTypeConfig(data) {
  return fetch({
      method: 'POST',
      url: 'houseTypeConfig/update',
      data
  })
}

// 删除房型下智能化配置
export function deleteIntellectImg(params) {
  return fetch({
    method: 'GET',
    url: 'houseTypeConfig/deleteIntellectImg',
    params
  })
}
